
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/plans",
      function () {
        return require("private-next-pages/account/plans/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/plans"])
      });
    }
  